// extracted by mini-css-extract-plugin
export default {"wrap":"Spacer_wrap__pZNap"};